import React from "react"
import styled from "styled-components"
import { ORDER_BY, ORDER } from "./constants"
import ascImg from "../images/ascending.svg"
import descImg from "../images/descending.svg"
import { ReactComponent as RandomIcon } from "../images/shuffle-outline.svg"
import clsx from "clsx"

const ORDER_NAME = {
  [ORDER_BY.COMMENT]: "댓글순",
  [ORDER_BY.COPIED]: "인기순",
  [ORDER_BY.CREATED_AT]: "시간순",
  [ORDER_BY.REACTION]: "반응순",
  [ORDER_BY.VIEW]: "조회순",
  [ORDER_BY.LAST_COPIED_AT]: "최근복사순",
  [ORDER_BY.LENGTH]: "길이순",
  [ORDER_BY.RANDOM]: "랜덤보기"
}

function OrderByRadio({
  orderBys = [],
  currentOrderBy,
  currentOrder,
  onChange,
  disable,
  disabledOrderBys = [],
  disabledReasons = {}
}) {
  return (
    <Container selected={currentOrderBy} order={currentOrder} disable={disable}>
      {orderBys.map((orderBy, i) => {
        const isDisabled = disable || disabledOrderBys.includes(orderBy)
        const tooltipText = isDisabled ? disabledReasons[orderBy] : null

        if (orderBy === ORDER_BY.RANDOM) {
          return (
            <div
              className={clsx(
                "sm:ml-4 cursor-pointer inline-flex h-8 items-center justify-center min-w-[32px] sm:px-[12px] bg-primary text-white rounded-[32px] text-sm gap-[6px] border border-[##EBEBEB]",
                isDisabled && "bg-[#DDDDDD] border-[#EBEBEB] cursor-not-allowed"
              )}
              key={i}
              onClick={() => onChange(orderBy, isDisabled)}
              disable={isDisabled}
              title={tooltipText}
            >
              <RandomIcon />
              <span className="sm:inline hidden-mobile">
                {ORDER_NAME[orderBy]}
              </span>
            </div>
          )
        }

        return (
          <OrderByItem
            id={orderBy}
            key={i}
            onClick={() => onChange(orderBy, isDisabled)}
            disable={isDisabled}
            title={tooltipText}
          >
            {ORDER_NAME[orderBy]}
            {!isDisabled && currentOrderBy === orderBy && (
              <img
                alt="order"
                src={currentOrder === ORDER.ASC ? ascImg : descImg}
              />
            )}
          </OrderByItem>
        )
      })}
    </Container>
  )
}

const Container = styled.div`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  color: black;
  pointer-events: ${props => (props.disable ? "none" : "inherit")};

  .hidden-mobile {
    @media (max-width: 639px) {
      display: none;
    }
  }

  @media (max-width: 800px) {
    top: 0;
    right: 16px;
  }
`

const OrderByItem = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  height: 2em;
  width: auto;
  padding: 0 8px;
  font-size: 1rem;
  line-height: 2em;
  text-align: center;
  color: ${props => (props.disable ? "#c5c5c5 !important" : "unset")};
  cursor: ${props => (props.disable ? "default" : "pointer")};
  img {
    width: 20px;
    height: 20px;
    margin-left: 6px;
  }
  ::after {
    display: inline-block;
    content: "";
    width: 1px;
    height: 1rem;
    margin-left: 8px;
    margin-right: -8px;
    background-color: #e4e4e4;
  }
  :last-child {
    &::after {
      display: none;
    }
  }
  @media (max-width: 800px) {
    height: 32px;
    font-size: 14px;
    line-height: 100%;
  }
`

export default OrderByRadio
